import type { CSSObject } from "@emotion/serialize";

import { size } from "./size";

export type Size = 10 | 11 | 12 | 13 | 14 | 15 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 30 | 34 | 40;

const remSize = (fontSize: number) => Array.from(String(fontSize), Number).join(".") + "rem";

export const fontSize = (fontSize: Size): CSSObject => {
  const emojiSize = fontSize > 20 ? fontSize - 2 : fontSize;

  return {
    fontSize: remSize(fontSize),
    ".ks": size(remSize(fontSize)),
    ".emoji": size(remSize(emojiSize)),
  };
};
